export const EXSBDOCUMENTTYPE_SHOW_RESET = 'EXSBDOCUMENTTYPE_SHOW_RESET'
export const EXSBDOCUMENTTYPE_SHOW_SET_ERROR = 'EXSBDOCUMENTTYPE_SHOW_SET_ERROR'
export const EXSBDOCUMENTTYPE_SHOW_SET_RETRIEVED = 'EXSBDOCUMENTTYPE_SHOW_SET_RETRIEVED'
export const EXSBDOCUMENTTYPE_SHOW_TOGGLE_LOADING = 'EXSBDOCUMENTTYPE_SHOW_TOGGLE_LOADING'
